export class SpecialDaysModel {
    fecha: Date;
    observaciones: string;

    constructor(fecha: Date, observaciones: string) {
        this.fecha = fecha;
        this.observaciones = observaciones;
    }
}